import { useTitle } from "react-use";

export function PageTitle({ children }: { children: string }) {
  useTitle(children);
  return null;
}
